/* global fetch */
// HyperLog – lightweight buffered client-side logger
// Writes to server every 0.5 s when HYPER_LOG=1 in .env (exposed via template variable)
// English comments as per project rules; Russian user communication elsewhere.

(function (global) {
  const ENABLED = (typeof window.HYPER_LOG !== 'undefined') ? window.HYPER_LOG === '1' : false;
  const MIN_LEVEL = (typeof window.HYPER_LOG_LEVEL !== 'undefined') ? window.HYPER_LOG_LEVEL : 'INFO';
  const DEBUG = (typeof global.debugMode !== 'undefined') ? (global.debugMode === '1') : false;
  // Unified UI logging endpoint (server writes to logs via Flask)
  const endpoint = '/api/logs/ui';
  const maxPayload = 32 * 1024; // 32 KB

  const buffer = [];
  let flushing = false;

  const levels = {
    INFO: 1,
    DEBUG: 0
  };

  function shouldSend(lvl) {
    return levels[lvl] >= levels[MIN_LEVEL];
  }

  function enqueue(lvl, msg, src) {
    if (!ENABLED || !shouldSend(lvl)) return;
    buffer.push({ lvl, msg, src });
  }

  function flush() {
    if (!ENABLED || flushing || buffer.length === 0) return;
    const payload = JSON.stringify({ logs: buffer.splice(0) });
    if (payload.length > maxPayload) {
      // payload too big – split and push back remainder
      const overflow = JSON.parse(payload).logs;
      buffer.unshift(...overflow);
      return;
    }
    flushing = true;
    fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: payload
    })
      .catch(() => { /* swallow errors */ })
      .finally(() => { flushing = false; });
  }

  setInterval(flush, 500);

  const HyperLog = {
    info: (msg, ctx = {}, src = 'ui') => {
      if (ENABLED || DEBUG) { console.info(msg, ctx); }
      enqueue('INFO', `${msg} ${JSON.stringify(ctx)}`, src);
    },
    debug: (msg, ctx = {}, src = 'ui') => {
      if (ENABLED || DEBUG) { console.debug(msg, ctx); }
      enqueue('DEBUG', `${msg} ${JSON.stringify(ctx)}`, src);
    }
  };

  global.HyperLog = HyperLog;
})(window); 